import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Notificacao } from '../../../../shared/interfaces/notificacao';
import { marcarNotificacaoVista } from '../../../utils/notificacao-vistas';

/** Página pública da notificação na Infokaw (a mesma que o desktop abre no navegador). */
const PAGINA_INFOKAW = 'https://infokaw.com.br/jkawflex/#/others/notificacao/';

@Component({
  selector: 'app-notification-detail',
  templateUrl: './notification-detail.component.html',
  styleUrls: ['./notification-detail.component.scss']
})
export class NotificationDetailComponent implements OnInit {

  notificacao: Notificacao;
  zoom = 1;
  urlPagina = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<NotificationDetailComponent>
  ) {}

  ngOnInit(): void {
    this.notificacao = this.data.payload;
    marcarNotificacaoVista(this.notificacao?.uuid);
    this.urlPagina = this.montarUrlPagina();
  }

  ajustarZoom(delta: number) {
    this.zoom = Math.min(1.6, Math.max(0.8, Math.round((this.zoom + delta) * 10) / 10));
  }

  /** 'acao' avisa quem abriu que o usuário seguiu o botão da campanha. */
  close(resultado?: 'acao') {
    this.dialogRef.close(resultado);
  }

  /**
   * Notificação da central abre na página da Infokaw (o id é de lá); a local abre
   * na rota desta mesma aplicação.
   */
  private montarUrlPagina(): string {
    const id = this.notificacao?.id;
    if (!id) {
      return '';
    }
    if (this.notificacao.fromInfokaw) {
      return PAGINA_INFOKAW + id;
    }
    return `${location.pathname}#/others/notificacao/${id}`;
  }

}
